<div class="dialog-header">
  <div class="dialog-icon-wrapper">
    <div class="dialog-icon new">
      <i class="fa-solid fa-key"></i>
    </div>
    <div>
      <h2 class="dialog-title">Change Password</h2>
      <p class="dialog-subtitle">Update your account password</p>
    </div>
  </div>
  <button class="dialog-close" (click)="onCancel()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<mat-dialog-content class="dialog-body">
  <form [formGroup]="passwordForm" class="password-form">
    @if( !data.disableCurrentPassword ) {
      <!-- Current Password -->
      <div class="dialog-field-group">
        <mat-label class="mat-form-field-label">Current Password <span class="req">*</span></mat-label>
        <mat-form-field appearance="outline">
          <input matInput [type]="hideCurrentPassword ? 'password' : 'text'" formControlName="currentPassword" placeholder="Enter current password">
          <i matSuffix [class]="hideCurrentPassword ? 'fa-regular fa-eye password-toggle-icon' : 'fa-regular fa-eye-slash password-toggle-icon'" (click)="togglePasswordVisibility('current')" matTooltip="Show/Hide"></i>
          @if (passwordForm.get('currentPassword')?.invalid && passwordForm.get('currentPassword')?.touched) {
            <mat-error>{{ currentPasswordError }}</mat-error>
          }
        </mat-form-field>
      </div>
    }

    <!-- New Password -->
    <div class="dialog-field-group">
      <mat-label class="mat-form-field-label">New Password <span class="req">*</span></mat-label>
      <mat-form-field appearance="outline">
        <input matInput [type]="hideNewPassword ? 'password' : 'text'" formControlName="newPassword" placeholder="Enter new password">
        <i matSuffix [class]="hideNewPassword ? 'fa-regular fa-eye password-toggle-icon' : 'fa-regular fa-eye-slash password-toggle-icon'" (click)="togglePasswordVisibility('new')" matTooltip="Show/Hide"></i>
        @if (passwordForm.get('newPassword')?.invalid && passwordForm.get('newPassword')?.touched) {
          <mat-error>{{ newPasswordError }}</mat-error>
        }
      </mat-form-field>
      <div class="password-hint">
        <i class="fa-solid fa-circle-info"></i>
        Password must be at least 8 characters long
      </div>
    </div>

    <!-- Confirm Password -->
    <div class="dialog-field-group">
      <mat-label class="mat-form-field-label">Confirm New Password <span class="req">*</span></mat-label>
      <mat-form-field appearance="outline">
        <input matInput [type]="hideConfirmPassword ? 'password' : 'text'" formControlName="confirmPassword" placeholder="Re-enter new password">
        <i matSuffix [class]="hideConfirmPassword ? 'fa-regular fa-eye password-toggle-icon' : 'fa-regular fa-eye-slash password-toggle-icon'" (click)="togglePasswordVisibility('confirm')" matTooltip="Show/Hide"></i>
        @if (passwordForm.get('confirmPassword')?.hasError('required')) {
            <mat-error>Please confirm your password</mat-error>
        }
        @if (passwordForm.get('confirmPassword')?.hasError('passwordMismatch')) {
            <mat-error>Passwords do not match</mat-error>
        }
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="dialog-footer">
  <button class="btn-ghost" (click)="onCancel()">Cancel</button>
  <button class="btn-blue" (click)="onSubmit()" [disabled]="!passwordForm.valid">
    Change Password
  </button>
</mat-dialog-actions>
